<template>
  <div>
    <v-layout
      row
      align-center
      mb-2
    >
      <v-flex xs2>
        <span :style="qtyStyle">{{ item.quantity }} x</span>
      </v-flex>
      <v-flex xs8>
        <span :style="nameStyle">{{ itemName }}
          <span
            v-if="item.voucher_id || item.is_promo"
            class="promotion"
          > ({{ $t('promotion_item') }})</span>
        </span>
        <div v-if="courseItems">
          <ul :style="listStyle">
            <li
              v-for="(name, index) in courseItems"
              :key="index"
            >{{ name }}</li>
          </ul>
        </div>
        <div v-if="toppings">
          <ul :style="listStyle">
            <li
              v-for="(name, index) in toppings"
              :key="index"
            >+add: {{ name }}</li>
          </ul>
        </div>
        <div v-if="options">
          <ul :style="listStyle">
            <li
              v-for="(name, index) in options"
              :key="index"
            >{{ $t('option') }}: {{ name }}</li>
          </ul>
        </div>
        <div v-if="item.remarks">
          <span :style="remarksStyle"
          >{{ $t('remarks') }}: {{ item.remarks }}</span>
        </div>
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
        :style="amountStyle"
      >
        {{ $n(amount, 'currency') }}
      </v-flex>
    </v-layout>
    <!-- <v-layout
      v-if="rid && item.category_id && catListIds.includes(item.category_id)"
      style="margin-top: -12px; margin-right: -8px"
    >
      <v-flex
        xs12
        text-xs-right
      >
        <v-btn
          dark
          small
          :color="theme.btn_color_primary"
          @click="orderItem"
        >Add</v-btn>
      </v-flex>
    </v-layout> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'order-item-component',
  props: {
    order: {
      type: String,
      default: null
    },
    item: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'rid', 'language'
    ]),
    ...mapGetters('menu', [
      'catListIds', 'items'
    ]),
    nameStyle () {
      return {
        fontWeight: 500,
        color: this.theme.cart_name_color
      }
    },
    listStyle () {
      return {
        listStyleType: 'none',
        paddingLeft: '0',
        fontSize: '12px',
        fontWeight: 400,
        color: this.theme.cart_name2_color
      }
    },
    qtyStyle () {
      return {
        color: this.theme.cart_qty_color
      }
    },
    amountStyle () {
      return {
        color: this.theme.cart_price_color
      }
    },
    remarksStyle () {
      return {
        color: this.theme.cart_remarks_color,
        fontSize: '13px'
      }
    },
    amount () {
      if (this.item) {
        if (this.item.final_price) {
          return parseFloat(this.item.final_price) * this.item.quantity
        }
        return parseFloat(this.item.price) * this.item.quantity
      }
      return 0
    },
    courseItems () {
      if (this.item.set_course_items.length > 0) {
        if (this.language !== 'en-SG') {
          return this.item.set_course_items.map(item => item.alternativeName || item.name)
        }
        return this.item.set_course_items.map(item => item.name)
      }
      return null
    },
    toppings () {
      if (this.item.toppings.length > 0) {
        if (this.language !== 'en-SG') {
          return this.item.toppings.map(item => item.alternativeName || item.name)
        }
        return this.item.toppings.map(item => item.name)
      }
      return null
    },
    options () {
      if (this.item.options.length > 0) {
        if (this.language !== 'en-SG') {
          return this.item.options.map(item => item.alternativeName || item.name)
        }
        return this.item.options.map(item => item.name)
      }
      return null
    },
    itemName () {
      if (this.language !== 'en-SG') {
        return this.item.alternativeName || this.item.name
      }
      return this.item.name
    }
  },
  methods: {
    async orderItem () {
      await this.$store.dispatch('menu/fetchCatItems', this.item.category_id)
      const key = 'c' + this.item.category_id
      const item = this.items[key].find(i => i.item_id === this.item.item_id)
      if (item) {
        this.$store.dispatch('menu/showMenuItemDialog', item)
        if (this.iOS && this.inIframe) {
          this.$router.push({ name: 'menu_item', params: { return: 'order', id: this.order }})
        }
      }
    }
  }
}
</script>

<style scoped>
.subtotal {
  color: red;
  font-weight: 500;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.sub-text {
  font-size: small;
}
.promotion {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderItem2.vue